export default "Aktuell sind keine Jobausschreibungen vorhanden.";